module.exports = __webpack_public_path__ + "static/media/seedsbesar.34c3d5c5.png";